"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetToolbar = void 0;
var react_1 = __importDefault(require("react"));
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var useSelectionState_1 = require("./useSelectionState");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetManager_1 = require("../WidgetManager");
var inversify_react_1 = require("inversify-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SyntheticSelection_1 = require("Project/SyntheticSelection");
var mobx_react_1 = require("mobx-react");
var Styleable_1 = require("./Styleable");
var HasTrait_1 = require("@CommonFrontend/WidgetRegistry/Utils/HasTrait");
exports.WidgetToolbar = (0, mobx_react_1.observer)(function (_a) {
    var element = _a.element, anchorElement = _a.anchorElement;
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var clearSelection = (0, SyntheticSelection_1.useSelectionStoreActions)().clearSelection;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var dragStore = (0, inversify_react_1.useInjection)("dragStore");
    var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type);
    var WidgetButtons = config === null || config === void 0 ? void 0 : config.toolbarButtons;
    var isAlignable = (0, EditorWidgetRegistry_1.isAlignableWidget)(element);
    var disableLeftAlignment = isAlignable && (0, EditorWidgetRegistry_1.isResizeableWidget)(element) && (element.data.width === "full" || element.data.width === "wide");
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 9 }, function () { return (react_1.default.createElement(kaleidoscope_1.Toolbar, { element: anchorElement, visible: widgetSelectionState === "circle" && !dragStore.isDragging, positionType: kaleidoscope_1.ToolbarPositionType.Element, autoStack: true },
        WidgetButtons ? react_1.default.createElement(WidgetButtons, { element: element }) : null,
        isAlignable ? (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.AlignLeft, null), "aria-label": "left align", selected: element.data.alignment === "left", onClick: function () {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                    action: "update",
                    path: widgetManager.getPath(element),
                    data: {
                        alignment: "left",
                    },
                }));
            }, disabled: disableLeftAlignment, tooltip: disableLeftAlignment
                ? { content: "Wide widgets can't be left aligned", size: kaleidoscope_1.TooltipSize.Large }
                : undefined })) : null,
        isAlignable ? (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.AlignCenter, null), "aria-label": "center align", selected: element.data.alignment === "center", onClick: function () {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                    action: "update",
                    path: widgetManager.getPath(element),
                    data: {
                        alignment: "center",
                    },
                }));
            } })) : null,
        (0, HasTrait_1.hasTrait)({ widgetType: element.type, traitName: "styleable" }) && !!anchorElement && (react_1.default.createElement(Styleable_1.StyleableWidgetToolbarButtons, { element: element, anchorElement: anchorElement })),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Delete, null), tooltip: { content: "Delete" }, onClick: function () {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                    action: "delete",
                    path: widgetManager.getPath(element),
                    type: element.type,
                }));
                clearSelection();
            }, isDestructive: true }))); }));
});
